export const disableScroll = () => {
    const body = document.body;

    let paddingOffset = window.innerWidth - body.offsetWidth + 'px';
    let pagePosition = window.scrollY;

    body.style.paddingRight = paddingOffset;
    body.classList.add('lock');
    body.dataset.position = pagePosition;
    body.style.top = -pagePosition + 'px';
}

export const enableScroll = () => {
    const body = document.body;

    let pagePosition = parseInt(body.dataset.position, 10);

    body.style.top = 'auto';
    body.classList.remove('lock');

    body.style.paddingRight = '0px';

    window.scroll({
        top: pagePosition,
        left: 0
    });

    body.removeAttribute('data-position');
}

export const checkBottom = (el) => {
    const rect = el.getBoundingClientRect();

    return rect.bottom <= window.innerHeight;
}

export const updateURLParameters = (paramsToUpdate) => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    for (const [param, value] of Object.entries(paramsToUpdate)) {
        if (value === null || value === '') {
            params.delete(param); // Remove the parameter if the value is empty or null
        } else {
            params.set(param, value); // Update or add a new parameter
        }
    }

    const newUrl = `${url.pathname}?${params.toString()}`;

    history.pushState(null, '', newUrl);
};

export const clearURLParameters = () => {
    const url = new URL(window.location.href);

    const newUrl = url.origin + url.pathname;

    history.pushState(null, '', newUrl);
}

export const createCookie = (name, value, days) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value}${expires}; path=/`;
};

export const readCookie = (name) => {
    const nameEQ = `${name}=`;
    return document.cookie
        .split('; ')
        .find((cookie) => cookie.startsWith(nameEQ))
        ?.split('=')[1] || null;
};

export const deleteCookie = (name) => {
    createCookie(name, '', -1);
}

export const wclFetch = async (data, method = 'POST') => {
    // const token = await getToken();

    // data.set('token', token);

    return fetch(config.ajax_url, {
        method: method,
        body: data,
        credentials: 'same-origin',
    });
}

export const getToken = async (action = 'submit') => {
    return await grecaptcha.execute(config.recaptcha_key, { action: 'submit' });
}

export const wclT = (key, value) => {
    const keys = key.split('.');

    let message = keys.reduce((obj, k) => (obj && obj[k] !== undefined) ? obj[k] : undefined, i18n);

    if (!message) {
        return;
    }

    if (value !== undefined) {
        message = message.replace('{n}', value); // Замінюємо плейсхолдер {n} на значення
    }

    return message;
}